import React from "react";
import { motion } from "framer-motion";
import { centerStats } from "../mock";

/**
 * "By the Numbers" — quiet editorial stats strip in the same warm
 * cream tone as the rest of the page. MIT/Stanford-style austerity:
 * trust typography and whitespace rather than dark blocks.
 */
const StatsBar = () => {
  return (
    <section
      id="stats"
      data-testid="stats-section"
      className="relative bg-[#FBF6E0] border-b border-gray-300"
    >
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="flex items-baseline gap-4 mb-10">
          <span className="text-[10px] font-mono uppercase tracking-[0.32em] text-gray-400">
            § 00
          </span>
          <span className="h-px w-10 bg-gray-900" />
          <span className="text-[10px] font-mono uppercase tracking-[0.32em] text-gray-700">
            The Center by the Numbers
          </span>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-x-6 gap-y-10 lg:divide-x lg:divide-gray-300">
          {centerStats.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{
                duration: 0.5,
                delay: i * 0.06,
                ease: [0.22, 1, 0.36, 1],
              }}
              className="lg:px-5 first:lg:pl-0 last:lg:pr-0"
              data-testid={`stat-${i}`}
            >
              <div className="text-[44px] sm:text-5xl lg:text-[56px] font-light text-gray-900 tracking-tight leading-none mb-2">
                {s.value}
              </div>
              <div className="text-[11px] font-mono uppercase tracking-[0.18em] text-[#00BCD4] mb-1">
                {s.label}
              </div>
              <div className="text-[11px] text-gray-600 font-light leading-snug">
                {s.note}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsBar;
